export default "__VITE_ASSET__M6q84$mw__"